<template>
  <div class="register-container">
    <el-card class="register-card">
      <h2 class="register-title">用户注册</h2>

      <el-alert v-if="inviteInfo" type="success" :closable="false" show-icon style="margin-bottom:16px">
        <template slot="title">
          您正在注册到 <strong>{{ inviteInfo.nickname || inviteInfo.username }}</strong> 名下
        </template>
      </el-alert>
      <el-alert v-if="inviteError" type="warning" :closable="false" show-icon style="margin-bottom:16px">
        {{ inviteError }}
      </el-alert>

      <el-form ref="form" :model="form" :rules="rules" label-width="0">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item prop="nickname">
          <el-input v-model="form.nickname" placeholder="请输入昵称" prefix-icon="el-icon-user-solid"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input v-model="form.confirmPassword" type="password" placeholder="请确认密码" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width:100%" @click="handleRegister">注 册</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="text" style="width:100%" @click="goLogin">已有账号？去登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'Register',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      form: { username: '', nickname: '', password: '', confirmPassword: '' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false,
      inviteCode: '',
      inviteInfo: null,
      inviteError: ''
    }
  },
  mounted() {
    // 清除可能存在的过期 token，避免干扰注册页面 API 调用
    localStorage.removeItem('token')
    this.inviteCode = this.$route.query.invite || ''
    if (this.inviteCode) {
      this.fetchInviteInfo()
    }
  },
  methods: {
    fetchInviteInfo() {
      api.getInviteInfo(this.inviteCode).then(res => {
        this.inviteInfo = res.data
      }).catch(() => {
        this.inviteError = '邀请码无效或已过期，注册后将默认归入总后台'
        this.inviteCode = ''
      })
    },
    handleRegister() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.loading = true
        const data = { username: this.form.username, nickname: this.form.nickname, password: this.form.password }
        if (this.inviteCode) {
          data.inviteCode = this.inviteCode
        }
        api.register(data)
          .then(res => {
            this.$message.success('注册成功，请登录')
            this.$router.push('/login')
          }).catch(() => {}).finally(() => { this.loading = false })
      })
    },
    goLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.register-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.register-card {
  width: 400px;
  padding: 20px;
}
.register-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}
</style>
